import { render, staticRenderFns } from "./tx-category-prefer.vue?vue&type=template&id=38347a10&"
import script from "./tx-category-prefer.ts?vue&type=script&lang=ts&"
export * from "./tx-category-prefer.ts?vue&type=script&lang=ts&"
import style0 from "./tx-category-prefer.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports